export default __webpack_public_path__ + "locales/az/Settings.json?hash=a7e5e2a16867d445d29b399a92e1a5f0";